import * as React from "react";
import { forwardRef } from "react";
const SvgAdTrust = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "#0078D4", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 12, r: 4 }), /* @__PURE__ */ React.createElement("circle", { cx: 17, cy: 12, r: 4 }), /* @__PURE__ */ React.createElement("path", { d: "M11 12h2M14 10l3-3m-3 7 3 3m-7-7L7 7m3 7-3 3" }));
const ForwardRef = forwardRef(SvgAdTrust);
export default ForwardRef;
